import { Box, Image } from "@chakra-ui/react"


export const NotFound=()=>{
    return(
        <Box w='100%' h='100vh'>
            <Image w='100%' h='100%' src='NOT FOUND.png'/>
        </Box>
    )
}